<template>
  <div>
    <!-- 点击 Report information errors 后弹出 -->
    <el-dialog
      :visible.sync="reportDialog"
      center
      custom-class="dialog_normal"
      :append-to-body="true"
      @close="cancelDialogC"
      v-if="reportDialog"
    >
      <div class="detail_cont report_box">
        <h3 class="margin-bottom20 detail_cont_title">Questions</h3>
        <h4 class="margin-bottom20">
          If you have any questions or concerns about your payments, usage, or
          account balance, please contact us. Our service team will promptly
          assist you and respond via email within 24 hours.
        </h4>

        <div>
          <el-form ref="reportForm" :model="reportForm" class="report_form">
            <div class="report_item">
              <div v-for="(report, index) in addReportList" :key="index">
                <div class="report_form_box">
                  <el-form-item label="How can we help">
                    <el-select
                      v-model="report.subject"
                      class="detail_cont_select"
                      placeholder="Please choose your question"
                      @change="subjectChange(report.subject)"
                      style="width: 100%"
                    >
                      <el-option
                        :label="item"
                        :value="item"
                        v-for="(item, index) in subjectOptions"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Provide more info">
                    <el-input
                      autocomplete="off"
                      v-model="report.demand"
                      type="textarea"
                      class="limit_box"
                      maxlength="200"
                      placeholder="Please enter a description of the shared content"
                      @input="inputChange(report.demand)"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="">
                    <span class="detail_cont_text_upload">Upload </span>
                    <el-upload
                      class="upload-demo"
                      style="display: inline-block"
                      :limit="1"
                      action="fakeaction"
                      ref="uploadFiletwo"
                      :on-exceed="handleExceed"
                      :http-request="
                        (params) => hanldUploadFiletwo(params, index)
                      "
                      :before-remove="
                        (params, list) => handleRemovetwo(params, list, index)
                      "
                      v-model="report.uploadFiles"
                      :file-list="report.filesList"
                    >
                      <el-button slot="trigger">Upload </el-button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="flex_center">
                <!-- <el-button class="btn_cancel" style="margin-left:30px"
                                    @click="cancelReport()">Cancel</el-button> -->
                <el-button
                  class="btn_export"
                  :disabled="disabledReport"
                  @click="onSubmitReport()"
                  >Submit</el-button
                >
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  billingAndPaymentcontactUs,
  billingAndPaymentupload,
  deleteFile,
} from "@/api/companyApi.js";
import crypto from "@/utils/crypto";
export default {
  props: {
    showReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: "701",
      filesList: [],
      subjectOptions: [
        "Payment issues",
        "Account balance issues",
        "Credit deduction issues",
        "Receipt issues",
        "Other issues",
      ],
      disabledReport1: true,
      disabledReport2: true,
      disabledReport: true,
      reportForm: { subject: "", demand: "" },
      addReportList: [
        { subject: "", demand: "", uploadFiles: [], filesList: [] },
      ],
      checked: false,
    };
  },
  computed: {
    reportDialog: {
      get() {
        return this.showReport;
      },
      set(newValue) {},
    },
  },
  created() {},
  methods: {
    // 文件上传限制
    handleExceed() {
      this.$message.warning(
        `The current limit is to select 3 files, with a total of ${
          this.form.uploadFiles.length + 1
        } files selected`,
      );
    },

    //关闭弹窗
    cancelDialogC() {
      this.$emit("closeReportDialog", false);
      this.addReportList = [
        { subject: "", demand: "", uploadFiles: [], filesList: [] },
      ];
    },

    handleRemovetwo(file, fileList, inde) {
      let index = fileList.findIndex((item) => item.name == file.name);
      const str = this.addReportList[inde].uploadFiles[index];
      let i = str.lastIndexOf("/");
      let result = str.substr(i + 1, str.length);
      this.addReportList[inde].uploadFiles.splice(index, 1);

      this.addReportList[inde].filesList.splice(index, 1);
      let params = { fileName: result };
      deleteFile(params).then((res) => {
        if (res && res.code) {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        }
      });
    },

    hanldUploadFiletwo(params, index) {
      let file = params.file;
      let form = new FormData();
      form.append("file", file);
      billingAndPaymentupload(form).then((res) => {
        if (res.code == 200) {
          // this.form.filesList.push({name:file.name,url:res.data});

          this.addReportList[index].uploadFiles.push(res.data);
          this.addReportList[index].filesList.push({
            name: file.name,
            url: res.data,
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
          let uid = file.uid;
          let idx = this.$refs.uploadFiletwo.uploadFiles.findIndex(
            (item) => item.uid === uid,
          );
          this.$refs.uploadFiletwo.uploadFiles.splice(idx, 1);
          // this.form.filesList.splice(idx, 1)
        }
      });
    },

    subjectChange(val) {
      if (val.length > 0) {
        this.disabledReport = false;
      } else {
        this.disabledReport = true;
      }
    },
    inputChange(val) {
      if (val.length > 0) {
        this.disabledReport = false;
      } else {
        this.disabledReport = true;
      }
    },
    //提交report
    onSubmitReport() {
      this.hanldSubmitReport();
    },
    async hanldSubmitReport() {
      this.reportDialog = false;

      let fileUrl = this.addReportList[0].uploadFiles[0];
      let rechargesNoList = this.$parent.Dowload.map(
        (item) => item.rechargesNo,
      );
      let param = {
        rechargesNoList: JSON.stringify(rechargesNoList),
        subject: this.addReportList[0].subject,
        message: this.addReportList[0].demand,
        fileUrl: fileUrl,
      };
      let res = await billingAndPaymentcontactUs(param);
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
        this.cancelDialogC();
      } else {
        this.$message({
          message: res.msg,
          center: true,
          type: "error",
        });
      }
    },
    //添加report表单
  },
};
</script>
<style scoped>
.upload-demo /deep/ .el-button {
  width: 210px;
  height: 60px;
  padding: 15px 66px;
  background: #eeeeee;
  border-radius: 10px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1290c9;
  line-height: 16px;
  text-align: center;
  font-style: normal;
}

.btn_cancel {
  width: 210px;
  height: 60px;
  background: #8497ab;
  border-radius: 10px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  font-style: normal;
}

.btn_export {
  width: 210px;
  height: 60px;
  background: #1290c9;
  border-radius: 10px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  font-style: normal;
}

.report_form_box {
  margin-bottom: 30px;
  border-radius: 10px;
}

.report_form /deep/ .el-input__inner {
  height: 50px;
  padding-right: 50px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: "Arial";
  font-size: 16px;
  line-height: 18px;
  font-style: normal;
}

.report_form /deep/ .el-form-item {
  margin-bottom: 20px;
}

.limit_box /deep/ .el-textarea__inner {
  height: 240px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: "Arial";
  font-size: 16px;
  line-height: 18px;
}

.report_form /deep/.el-form-item__label,
.report_box h4 {
  font-family: "Arial";
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.report_form /deep/.el-form-item__label {
  margin-bottom: 10px;
}

.detail_cont .el-upload-list__item {
  display: flex;
}

.report_form /deep/ .el-upload-list {
  position: absolute;

  top: 15%;
  left: 42%;
}

.el-upload-list__item-status-label {
  display: inline-block;
}

.el-upload-list__item:hover .el-upload-list__item-status-label {
  display: none;
}

.detail_cont .el-upload-list__item-status-label,
.detail_cont .el-upload-list__item .el-icon-close {
  position: static;
}

.detail_cont .el-upload-list__item .el-icon-close {
  line-height: 22px;
}

.dialog_detail_check .el-checkbox .el-checkbox__label {
  width: 352px;
  display: inline-block;

  position: relative;
  font-size: 16px;
  color: #1a2332;
}

.dialog_detail_title {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 18px !important;
  font-family: "Arial Bold";
}

.dialog_detail_check .el-checkbox {
  display: flex;
  align-items: center;
  white-space: normal;
}

/deep/ .el-checkbox__input {
  white-space: normal;
}

/deep/ .el-upload-list__item-name {
  padding-left: 0;
  font-size: 12px;
  color: #1a2332;
}

.detail_cont_title {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 26px;
  color: #1a2332;
  line-height: 27px;
  text-align: center;
  font-style: normal;
}

::v-deep .dialog_normal {
  width: 800px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 30px;
}

.el-select-dropdown__item {
  font-family: "Arial";
  font-size: 16px !important;
  line-height: 34px;
  font-style: normal;
}

.detail_cont_select ::v-deep .el-input__icon {
  margin-right: 14px;
}

.detail_cont_text_upload {
  margin-right: 20px;
  font-family: "Arial";
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  text-align: justify;
  font-style: normal;
}

@media screen and (max-width: 1920px) {
  .upload-demo /deep/ .el-button {
    width: 158px;
    height: 45px;
    padding: 11px 50px;
    border-radius: 7px;
    font-size: 16px;
    line-height: 12px;
  }

  .btn_cancel {
    width: 158px;
    height: 45px;
    border-radius: 7px;
    font-size: 16px;
    line-height: 22px;
  }

  .btn_export {
    width: 158px;
    height: 45px;
    border-radius: 7px;
    font-size: 16px;
    line-height: 22px;
  }

  .report_form_box {
    margin-bottom: 22px;
    border-radius: 7px;
  }

  .report_form /deep/ .el-input__inner {
    height: 38px;
    padding-right: 38px;
    border-radius: 7px;
    font-size: 14px;
    line-height: 16px;
  }

  .report_form /deep/ .el-form-item {
    margin-bottom: 15px;
  }

  .limit_box /deep/ .el-textarea__inner {
    height: 180px;
    border-radius: 7px;
    font-size: 14px;
    line-height: 16px;
  }

  .report_form /deep/.el-form-item__label,
  .report_box h4 {
    font-size: 16px;
    line-height: 22px;
  }

  .report_form /deep/.el-form-item__label {
    margin-bottom: 7px;
  }

  .detail_cont .el-upload-list__item .el-icon-close {
    line-height: 16px;
  }

  .dialog_detail_check .el-checkbox .el-checkbox__label {
    width: 264px;
    font-size: 14px;
  }

  .dialog_detail_title {
    font-size: 16px;
    margin-bottom: 14px !important;
  }

  .detail_cont_title {
    font-size: 20px;
    line-height: 20px;
  }

  ::v-deep .dialog_normal {
    width: 600px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 22px;
  }

  .el-select-dropdown__item {
    font-size: 14px !important;
    line-height: 26px;
  }

  .detail_cont_select ::v-deep .el-input__icon {
    margin-right: 10px;
  }

  .detail_cont_text_upload {
    margin-right: 15px;
    font-size: 16px;
    line-height: 22px;
  }
}

@media screen and (max-width: 1439px) {
  .upload-demo /deep/ .el-button {
    width: 158px;
    height: 40px;
    padding: 10px 44px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 16px;
  }

  .btn_cancel {
    width: 158px;
    height: 40px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .btn_export {
    width: 158px;
    height: 40px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .report_form_box {
    margin-bottom: 20px;
    border-radius: 6px;
  }

  .report_form /deep/ .el-input__inner {
    height: 38px;
    padding-right: 38px;
    border-radius: 6px;
    font-size: 12px;
    line-height: 14px;
  }

  .report_form /deep/ .el-form-item {
    margin-bottom: 12px;
  }

  .limit_box /deep/ .el-textarea__inner {
    height: 160px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 16px;
  }

  .report_form /deep/.el-form-item__label,
  .report_box h4 {
    font-size: 14px;
    line-height: 20px;
  }

  .report_form /deep/.el-form-item__label {
    margin-bottom: 6px;
  }

  .detail_cont .el-upload-list__item .el-icon-close {
    line-height: 14px;
  }

  .dialog_detail_check .el-checkbox .el-checkbox__label {
    width: 236px;
    font-size: 12px;
  }

  .dialog_detail_title {
    font-size: 14px;
    margin-bottom: 12px !important;
  }

  .detail_cont_title {
    font-size: 18px;
    line-height: 20px;
  }

  ::v-deep .dialog_normal {
    width: 536px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 20px;
  }

  .el-select-dropdown__item {
    font-size: 12px !important;
    line-height: 22px;
  }

  .detail_cont_select ::v-deep .el-input__icon {
    margin-right: 9px;
  }

  .detail_cont_text_upload {
    margin-right: 12px;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
